<template>
  <div
    class="mf-table"
    ref="mf_table_container"
    
  >
    <el-table
      :data="dataList"
      @sort-change="sortChange"
      :empty-text="'暂无数据'"
      :default-sort="table.defaultSort"
      :header-cell-style="tableHeaderColor"
      @selection-change="handleSelectionChange"
      :default-expand-all="table.tableOption.expandAll"
      :row-key="table.tableOption.rowKey"
      :tree-props="table.tableOption.treeProps"
      :span-method="spanMethod"
      :row-class-name="table.tableOption.tableRowClassName"
      style="width: 100%"
      :height="
        table.tableOption.fixedHeight
          ? table.tableOption.fixedHeight
          : mf_table_top
      "
      ref="mf_table"
      @current-change="handleCurrentChange"
      highlight-current-row
      border
      @select="select"
      @select-all="selectAll"
      :key="index"
    >
      <template slot="empty">
        <div class="empty-box">
          <img :src="require('../../../assets/images/empty-data.png')">
            <!-- <p>{{dataListLoading?"加载中。。。":"空空如也"}}</p> -->
            <p>{{"空空如也"}}</p>
        </div>
      </template> 
      <!-- 选择框 -->
      <el-table-column
        v-if="table.tableOption.isSelection"
        type="selection"
        align="center"
        width="55"
      ></el-table-column>
      <!-- 序号列 -->
      <el-table-column
        v-if="table.tableOption.isIndex"
        type="index"
        :label="table.tableOption.indexLabel || '序号'"
        align="center"
        width="50"
      ></el-table-column>
      <!-- 内容列 -->
      <template v-for="(item, index) in table.tableLabel">
      <el-table-column
        :key="`${item.prop}-${index}`"
        :type="item.type"
        :fixed="item.fixed"
        :prop="item.prop"
        :min-width="item.width || 100"
        :sortable="item.sort"
        :show-overflow-tooltip="item.ellipsis"
        :label="item.label"
        :align="item.align || 'center'"
        :filters="item.filters && item.filters.options"
        :filter-method="item.filters && item.filters.fun"
        :filter-placement="item.filters && item.filters.filterPlacement"
        v-if="!item.columnHide||!item.columnHide()"
      >
        <template slot-scope="scope">
          <!-- html -->
          <span
            v-if="item.type === 'Html'"
            v-html="item.html(scope.row[item.prop])"
          ></span>
          <!-- 开关 -->
          <el-switch
            v-if="item.type === 'Switch'"
            v-model="scope.row[item.prop]"
            :active-value="item.acVal"
            :inactive-value="item.inacVal"
            :disabled="item.formatter && item.formatter(scope.row)"
            @change="item.change && item.change(scope.row)"
          ></el-switch>
          <!-- 图像 -->
          <img
            v-if="item.type === 'Image'"
            :src="scope.row[item.prop]"
            @click="item.handle && item.handle(scope.row)"
            style="max-width:50px;max-height: 20px;"
          />
          <!-- 多选框 -->
          <el-checkbox
            v-if="item.type === 'Checkbox'"
            :disabled="item.isDisabled && item.isDisabled(scope.row)"
            v-model="scope.row[item.prop]"
          ></el-checkbox>
          <!-- 标签 -->
          <el-tag
            size="small"
            v-if="item.type === 'Tag'"
            :type="item.formatter(scope.row)"
          >{{ scope.row[item.prop] }}</el-tag>
          <span v-if="item.type == 'Status'">
            <i class="statusPoint iconfont iconpoint" :style="{color: statusFile(item.list,scope.row[item.prop])}"></i>{{scope.row[item.prop]}}
          </span>
          <!-- 滑块 -->
          <el-slider
            v-if="item.type === 'Slider'"
            v-model="scope.row[item.prop]"
            :disabled="item.isDisabled && item.isDisabled(scope.row)"
            @change="item.change && item.change(scope.row)"
          ></el-slider>
          <!-- 图标 -->
          <i
            v-if="item.type === 'Icon'"
            :class="item.formatter(scope.row) + ' table_row_icon'"
          ></i>
          <!-- 下拉框 -->
          <el-select
            v-model="scope.row[item.prop]"
            v-if="item.type === 'Select'"
            :disabled="item.isDisabled && item.isDisabled(scope.row)"
            @change="item.change && item.change(scope.row)"
            size="mini"
          >
            <el-option
              v-for="val in item.options"
              :key="val[item.key]"
              :label="val[item.selectLabel]"
              :value="val[item.key]"
            >
            </el-option>
          </el-select>
          <!-- 输入框 -->
          <el-input
            v-if="item.type === 'Input'"
            v-model="scope.row[item.prop]"
            :disabled="item.isDisabled && item.isDisabled(scope.row)"
            size="mini"
          ></el-input>
          <!-- 日期 -->
          <el-date-picker
            v-if="item.type === 'Date'"
            v-model="scope.row[item.prop]"
            :disabled="item.isDisabled && item.isDisabled(scope.row)"
            :format="item.format || 'yyyy-MM-dd HH:mm:ss'"
            :type="item.dateType || 'date'"
            size="mini"
            placeholder="选择日期"
            @change="item.change && item.change(scope.row)"
          >
          </el-date-picker>
          <!-- 数字框 -->
          <el-input
            v-if="item.type === 'Number'"
            type="number"
            v-model="scope.row[item.prop]"
            :disabled="item.isDisabled && item.isDisabled(scope.row)"
            size="mini"
          ></el-input>
          <!-- 文字提示 -->
          <el-tooltip
            v-if="item.type === 'Tooltip'"
            class="item"
            effect="light"
            :content="scope.row[item.prop]"
            placement="top"
          >
            <span>{{
              scope.row[item.prop].length > 30
                ? scope.row[item.prop].slice(0, 30) + "..."
                : scope.row[item.prop]
            }}</span>
          </el-tooltip>
          <!-- 默认 -->
          <span
            v-if="!item.type"
            :style="item.itemStyle && item.itemStyle(scope.row)"
            :class="item.itemClass && item.itemClass(scope.row)"
            @click="item.fun && item.fun(scope.row)"
          >
            {{
              (item.formatter && item.formatter(scope.row)) ||
              scope.row[item.prop]
            }}</span>
        </template>
      </el-table-column>
      </template>
      <!-- 操作列 -->
      <el-table-column
        v-if="table.tableOption.action && !table.tableOption.noTableEdit"
        fixed="right"
        align="center"
        header-align="center"
        label="操作"
        :width="table.tableOption.actionWidth || 160"
      >
        <template slot-scope="scope">
          <template>
            <span v-show="table.tableOption.ApprovalLog"><span class="tooltipItemStyle" @click="Openlog(scope.row)" v-if="table.tableOption.ApprovalLogName">{{table.tableOption.ApprovalLogName}}</span>
            <span class="tooltipItemStyle" @click="Openlog(scope.row)" v-if="table.tableOption.ApprovalLogName==undefined">审批日志</span></span>
            <span 
              v-for="btn in table.tableOption.action" 
              :key='btn.title'
              v-show='btn.show(scope.row) && hasPremission(btn.premission)'
              :disabled="btn.disabled && btn.disabled(scope.row)">
              <span class="tooltipItemStyle" @click="handleClick(scope.row, btn.fun, scope)">{{btn.name}}</span>
            </span>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页条 -->
    <div
      class="table-pagination"
      v-if="tablePagination.getDataListIsPage"
    >
    <!-- {{tablePagination.pageIndex}}
    {{tablePagination.pageSize}}
    {{tablePagination.total}} -->
      <el-pagination
        background
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
        :current-page="Number(tablePagination.pageIndex)"
        :page-size="Number(tablePagination.pageSize)"
        layout="total, sizes, prev, pager, next"
        :total="Number(tablePagination.total)"
      >
      </el-pagination>
    </div>
    <el-dialog title="审批日志" :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false" width="50%">
      <el-form :model="logform" ref="logform" label-width="120px" class="demo-ruleForm" size="mini">
        <el-form-item>
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in logform.histories"
              :key="index"
              :timestamp="activity.ApprovalTime">
              <el-tag type="success" v-if="activity.ApproveResult==1">审批通过 -- {{activity.ApproverName}}</el-tag>
              <el-tag type="info" v-if="activity.ApproveResult==0">审批中 -- {{activity.ApproverName}}</el-tag>
              <el-tag type="info" v-if="activity.ApproveResult==-1">提交审批 -- {{activity.ApproverName}}</el-tag>
              <el-tag type="danger" v-if="activity.ApproveResult==2">审批拒绝 -- {{activity.ApproverName}}</el-tag>
              <br/>
              <span v-if="activity.ApproveContent != ''">拒绝理由: {{activity.ApproveContent}}</span>
            </el-timeline-item>
          </el-timeline>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import ApiUrls from '@/api/apiUrls'
export default {
  name: "MfTable",
  data() {
    return {
      mf_table_top: 0,
      row: {},
      dialogVisible:false,
      logform:{
        histories:[]
      },
      index:1
    };
  },
  props: {
    table: {
      type: Object,
      default: () => { },
    },
    dataList: {
      type: Array,
      default: () => [],
    },
    tablePagination: {
      type: Object,
      default: () => { },
    },
  },
  mounted() {
    window.onresize = () => {
      this.fetTableHeight();
    };
    this.fetTableHeight();
  },
  activated() {
    //激活table列表时 把数据过滤下 只保留显示的操作按钮
    this.filterTableData()
    this.fetTableHeight();
    window.onresize = () => {
      this.fetTableHeight();
    };
  },
  watch: {
  },
  methods: {
    hasPremission(premission){
      if(premission!=null && premission!="" && premission!=undefined){
        let permissions = JSON.parse(localStorage.getItem("permissions"));
        // 按组名获取权限列表，
        if(permissions.indexOf(premission) == -1){
          return false;
        }else{
          return true;
        }
      }else{
        return true;
      }
    },
    Openlog(row){
      this.$reqPost(ApiUrls.GetApprovalHistory+"?DataId="+row.Id,{}).then(res=>{
        if (res.isSuccess===true){
          this.dialogVisible = true;
          this.logform.histories = res.result;
        }
      })
    },
    statusFile(list,value){
      console.log(list)
      let data = list.filter((item)=>{
        console.log(item,value)
        return item.value==value
      })
      return "" || data[0].color;
    },
    filterTableData(){
      let self = this
      self.table.tableOption.action.filter((x)=>{
        if(!x.show){
          self.table.tableOption.action.splice(i,1)
        }
      })
    },
    //重置table高度
    resetHeight() {
      return new Promise((resolve, reject) => {
        this.mf_table_top = 0;
        resolve();
      });
    },
    //设置table高度
    fetTableHeight() {
      this.resetHeight().then((res) => {
        this.mf_table_top =
          document.documentElement.clientHeight -
          this.$refs.mf_table_container.getBoundingClientRect().top -
          65 +
          (!this.tablePagination.getDataListIsPage ? 40 : 0);
        this.$refs.mf_table.doLayout();
      });
    },
    //排序
    sortChange() { },
    //分页, 每页条数
    pageSizeChangeHandle(val) {
      this.tablePagination.pageSizeChangeHandle &&
        this.tablePagination.pageSizeChangeHandle(val);
    },
    //分页, 当前页
    pageCurrentChangeHandle(val) {
      console.log('当前分页',val)
      this.tablePagination.pageCurrentChangeHandle &&
        this.tablePagination.pageCurrentChangeHandle(val);
    },
    //table行选择
    handleSelectionChange(row) {
      this.table.tableOption.selectionFun &&
      this.table.tableOption.selectionFun(row);
    },
    //操作按钮点击事件
    handleClick(row, fun, scope) {
      fun && fun(row, scope);
    },
    //操作按钮更多点击事件
    handleCommand(command, row,btnArgument) {
      let data = this.table.tableOption.action.slice(
        2,
        this.table.tableOption.action.length
      );
      data[command].fun && data[command].fun(row,btnArgument);
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return "background-color:#FAFAFA;font-size: 14px;color: rgba(0,0,0,0.65);height: 54px;border-right: none;";
    },
    //表格行点击事件
    handleCurrentChange(row) {
      this.table.tableOption.currentChange &&
        this.table.tableOption.currentChange(row);
    },
    //限制表格单选
    select(selection) {
      if (this.table.tableOption.isSelectOne && selection.length > 1) {
        let del_row = selection.shift();
        this.$refs.mf_table.toggleRowSelection(del_row, false);
      }
    },
    selectAll(selection) {
      if (this.table.tableOption.isSelectOne && selection.length > 1) {
        selection.length = 1;
      }
    },
    //合并行和列
    spanMethod({ row, column, rowIndex, columnIndex }) {
    },

    compare(data, newData, key) {
      data.forEach((e) => {
        //新建属性名
        if (Object.keys(newData).indexOf("" + e[key]) === -1) {
          newData[e[key]] = [];
        }
        //对应插入属性值
        newData[e[key]].push(e);
      });
    },

    a1(newData, colMerge, lev) {
      lev = lev + 1;
      console.log(lev);
      Object.keys(newData).forEach((e) => {
        let data = JSON.parse(JSON.stringify(newData[e]));
        this.compare(data, (newData[e] = {}), colMerge[lev]);
        if (lev < colMerge.length) {
          this.a1(newData[e], colMerge[lev + 1], lev);
        }
      });
    },

    //数据按colMerge字段分类
    dataMerge(data, colMerge) {
      let newData = {};
      let lev = 0;
      if (colMerge.length) {
        this.compare(data, newData, colMerge[lev]);
      }
      console.log("newData", newData);
      this.a1(newData, colMerge, lev);
      console.log(newData);
      return newData;
    },
    forceUpdate(){
      this.index += 1;
    }
  },
};
</script>
<style>
i.statusPoint{font-size:14px;}
</style>



